
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoalibaugelloracabs() {



    const cardData =
    {
        keyword: 'Pune to Ajanta Ellora Cabs',
        heading: 'Platinum24 Cabs: Pune to Ajanta Ellora Cabs',
        headingDescription: ' Platinum24 Cabs offers reliable Pune to Ajanta Ellora Cabs, perfect for tourists, history enthusiasts, and family travelers exploring Maharashtra’s UNESCO World Heritage Sites. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a comfortable journey with air-conditioned rides and spacious seating. With professional chauffeurs experienced in long-distance travel, we guarantee safe, punctual, and hassle-free trips to Ajanta and Ellora caves. Whether it’s a one-way drop, round-trip, or a full sightseeing tour, Platinum24 Cabs provides affordable fares, transparent packages, and dependable service for your Pune to Ajanta Ellora journey.',

        top: 'Top Places to Visit in Ajanta Ellora with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Ajanta Caves",
    "description": "The Ajanta Caves, dating back to the 2nd century BCE, are world-famous for their Buddhist rock-cut architecture and exquisite paintings. The 30 caves depict Jataka tales of Buddha’s previous lives. Frescoes and murals here are considered masterpieces of ancient Indian art. The caves also feature chaitya halls and viharas. Surrounded by a horseshoe-shaped gorge of the Waghora River, they create a serene setting. Ajanta is Maharashtra’s artistic jewel of heritage."
  },
  {
    "title": "Ellora Caves",
    "description": "Ellora Caves, near Aurangabad, consist of 34 rock-cut temples and monasteries built between the 6th and 10th centuries. They showcase Hindu, Buddhist, and Jain traditions in perfect harmony. The site reflects India’s religious tolerance and artistic brilliance. Sculptures and carvings here are awe-inspiring. The caves are spread over 2 km of rocky terrain. Ellora is Maharashtra’s timeless symbol of cultural unity."
  },
  {
    "title": "Kailasa Temple (Cave 16, Ellora)",
    "description": "The Kailasa Temple at Ellora is the world’s largest monolithic rock excavation. Carved from a single rock, it is dedicated to Lord Shiva. The temple resembles Mount Kailash and features intricate carvings of gods, demons, and mythological scenes. Its architecture is an engineering marvel of ancient India. The temple leaves visitors spellbound with its scale and artistry. Kailasa is Ellora’s crowning glory."
  },
  {
    "title": "Bibi Ka Maqbara",
    "description": "Often called the ‘Taj Mahal of the Deccan,’ Bibi Ka Maqbara was built by Aurangzeb’s son Azam Shah in memory of his mother. Located near Aurangabad, it features Mughal-style gardens, marble domes, and ornate minarets. Though smaller than the Taj Mahal, it is equally enchanting. Evening lighting adds to its charm. It is a popular stop for Ajanta–Ellora travelers. Bibi Ka Maqbara is Aurangabad’s Mughal heritage gem."
  },
  {
    "title": "Grishneshwar Jyotirlinga Temple",
    "description": "Grishneshwar Temple, near Ellora, is one of the 12 Jyotirlingas of Lord Shiva. Built in red stone, it showcases exquisite carvings and Hemadpanti architecture. Pilgrims flock here for blessings and spiritual energy. The temple was rebuilt by Queen Ahilyabai Holkar in the 18th century. Festivals like Mahashivratri are celebrated grandly. Grishneshwar is Ellora’s divine pilgrimage highlight."
  },
  {
    "title": "Daulatabad Fort",
    "description": "Daulatabad Fort, located on a conical hill near Ellora, is one of India’s strongest forts. Known for its massive walls, secret passages, and Chand Minar, it is an engineering wonder of medieval times. The fort was once the capital under Sultan Muhammad bin Tughlaq. Trekkers enjoy climbing to the top for panoramic views. Its defense structures fascinate historians. Daulatabad is Maharashtra’s invincible hill fort."
  },
  {
    "title": "Aurangabad Caves",
    "description": "The Aurangabad Caves, carved between the 6th and 8th centuries, are lesser-known Buddhist monuments. They feature chaityas and viharas adorned with sculptures of deities. The caves depict tantric influences in Buddhist art. Located on a hill overlooking the city, they offer peaceful views. The site is quiet and less crowded compared to Ajanta and Ellora. Aurangabad Caves are the city’s hidden heritage spot."
  },
  {
    "title": "Panchakki (Water Mill)",
    "description": "Panchakki, a 17th-century water mill in Aurangabad, was designed to grind grain for pilgrims and soldiers. It is powered by a clever underground water channel system. The site also has a Sufi dargah, garden, and fish tank. Visitors admire its engineering brilliance. The peaceful setting makes it a pleasant stop. Panchakki is Aurangabad’s historic blend of science and spirituality."
  },
  {
    "title": "Pitalkhora Caves",
    "description": "Located 40 km from Ellora, the Pitalkhora Caves are among the oldest rock-cut Buddhist caves in India. Dating back to the 2nd century BCE, they feature chaityas, stupas, and decorative carvings. The caves are set amidst a scenic valley with waterfalls. Though partly damaged, they reflect early Buddhist art. They are ideal for history enthusiasts and trekkers. Pitalkhora is Maharashtra’s ancient Buddhist heritage site."
  },
  {
    "title": "Lonar Lake",
    "description": "Lonar Lake, about 140 km from Ajanta–Ellora, is the world’s only high-saline, soda lake formed by a meteor impact. Surrounded by forests and temples, it is a geological wonder. Scientists, photographers, and pilgrims visit for its uniqueness. The temples around the crater, like Daitya Sudan Temple, add historical charm. Monsoon enhances its beauty. Lonar Lake is Maharashtra’s rare natural marvel."
  }
],


      "services": [
    {
      "name": "Pune to Ajanta Ellora Taxi",
      "description": "Explore the UNESCO World Heritage Sites of Ajanta and Ellora Caves with our reliable Pune to Ajanta Ellora Taxi service. Enjoy a smooth, air-conditioned ride through scenic landscapes, guided by professional drivers familiar with the route and nearby amenities. Our taxis are equipped for long-distance travel, offering comfortable seating, ample luggage space, and optional add-ons like refreshments and curated sightseeing stops."
    },
    {
      "name": "Ajanta Ellora Cab from Pune",
      "description": "Book a comfortable Ajanta Ellora Cab from Pune for a culturally enriching experience. Whether you’re traveling solo, with family, or in a group, we offer multiple vehicle types like sedans, SUVs, and tempo travellers. Enjoy the flexibility of custom itineraries, guided visits upon request, and assured safety with our well-trained drivers and sanitized vehicles."
    },
    {
      "name": "Pune Ajanta Ellora Taxi Booking",
      "description": "Use our fast and easy Pune Ajanta Ellora Taxi Booking platform to plan your trip seamlessly. Choose between one-way or round-trip options, select your preferred car category, and get instant fare estimates. Our booking interface is mobile-friendly and offers real-time confirmation with no hidden fees. Customer support is available 24x7 to assist with route planning, timing, or changes in your itinerary."
    },
    {
      "name": "Taxi Service Pune to Ajanta Ellora",
      "description": "Our Taxi Service from Pune to Ajanta Ellora is designed for comfort, reliability, and affordability. Enjoy flexible pickup times, driver assistance, and optional detours to nearby attractions such as Daulatabad Fort, Grishneshwar Temple, and Aurangabad city. We ensure your travel is safe and memorable with trained drivers, GPS tracking, and premium vehicle options."
    },
    {
      "name": "Ajanta Ellora Cab Rental Pune",
      "description": "Rent a cab from Pune to Ajanta Ellora with flexible plans including per kilometer rates or full-day packages. Our fleet includes economy and luxury models, all well-maintained and driven by courteous chauffeurs. With GPS navigation, clean interiors, and route knowledge, our cab rental ensures a worry-free ride to one of India’s most iconic destinations."
    },
    {
      "name": "Pune to Ajanta Ellora Taxi Fare",
      "description": "Our Pune to Ajanta Ellora Taxi Fare is transparent and budget-friendly. Get competitive pricing across all car categories, including sedans, SUVs, and tempo travellers. Fare includes fuel, driver allowance, and taxes—no surprises. Use our fare calculator online to estimate your cost and choose what suits your needs."
    },
    {
      "name": "Ajanta Ellora Private Taxi Pune",
      "description": "Travel at your own pace with our Ajanta Ellora Private Taxi from Pune. Ideal for families, senior citizens, and small groups, this service offers maximum privacy, personalized pit stops, and driver flexibility. Avoid the rush and enjoy cultural heritage at your leisure with door-to-door pickup and drop."
    },
    {
      "name": "Ajanta Ellora Cab Packages Pune",
      "description": "Choose from specially curated Ajanta Ellora Cab Packages from Pune that include multiple sightseeing options, hotel pickups, and optional guides. Packages are available for 1-day, 2-day, or custom durations with discounts on round-trips and group bookings. Travel smart with our all-inclusive packages covering tolls, parking, and driver charges."
    },
    {
      "name": "Pune to Ajanta Ellora One Way Cab",
      "description": "Book a one-way cab from Pune to Ajanta Ellora for an economical travel solution. Whether you’re relocating, visiting relatives, or planning a one-way tour, our cabs offer comfortable, AC travel with no obligation to return. One-way bookings are available with sedans, SUVs, and luxury vehicles."
    },
    {
      "name": "Taxi Charges Pune to Ajanta Ellora",
      "description": "Check updated Taxi Charges from Pune to Ajanta Ellora through our booking portal. Charges vary based on vehicle type, trip duration, and optional services like overnight stay. We offer flat pricing on most standard routes to ensure transparency and avoid last-minute confusion."
    },
    {
      "name": "Pune to Ajanta Ellora Taxi Hire",
      "description": "Hire a taxi from Pune to Ajanta Ellora with flexible duration options—perfect for day trips or multi-day explorations. Choose from hourly or per-kilometer billing. Our taxi hire comes with experienced drivers who understand tourist preferences and can guide you to the best food, rest stops, and photo points en route."
    },
    {
      "name": "Ajanta Ellora Pilgrimage Taxi Pune",
      "description": "If you’re visiting Ajanta Ellora for religious or cultural reasons, our Pilgrimage Taxi from Pune offers a respectful and comfortable travel experience. The service includes spiritual stopovers at places like Grishneshwar Jyotirlinga and nearby temples. We also cater to senior citizens and large families with suitable cab types."
    },
    {
      "name": "Pune Ajanta Ellora Outstation Taxi",
      "description": "Our Outstation Taxi from Pune to Ajanta Ellora offers a safe and reliable option for long-distance travel. Vehicles are certified for outstation travel, come with travel insurance options, and include overnight driver accommodations if required. Ideal for both short tours and extended stays in Aurangabad or beyond."
    },
    {
      "name": "Ajanta Ellora Taxi with Driver Pune",
      "description": "Hire our Ajanta Ellora Taxi with Driver from Pune for a smooth and chauffeur-driven experience. Our drivers are background-verified, fluent in multiple languages, and trained for long routes. They assist with luggage, local insights, and sightseeing suggestions, ensuring a stress-free journey."
    },
    {
      "name": "Taxi Service Pune to Ajanta Ellora",
      "description": "Make your Pune to Ajanta Ellora trip memorable with our premium Taxi Service, offering curated travel options for families, students, corporate groups, and solo travelers. Book online, get instant confirmation, and enjoy a relaxed, scenic drive to one of Maharashtra’s most treasured destinations."
    }
  ],
  "tableData": [
    ["Pune to Ajanta Ellora Taxi", "Ajanta Ellora Cab from Pune"],
    ["Pune Ajanta Ellora Taxi Booking", "Taxi Service Pune to Ajanta Ellora"],
    ["Ajanta Ellora Cab Rental Pune", "Pune to Ajanta Ellora Taxi Fare"],
    ["Ajanta Ellora Private Taxi Pune", "Ajanta Ellora Cab Packages Pune"],
    ["Pune to Ajanta Ellora One Way Cab", "Taxi Charges Pune to Ajanta Ellora"],
    ["Pune to Ajanta Ellora Taxi Hire", "Ajanta Ellora Pilgrimage Taxi Pune"],
    ["Pune Ajanta Ellora Outstation Taxi", "Ajanta Ellora Taxi with Driver Pune"],
    ["Taxi Service Pune to Ajanta Ellora", "—"]
  ],


         "whychoose": [
    {
      "WhyChooseheading": "Reliable Pune to Ajanta Ellora Cab Service",
      "WhyChoosedescription": "Platinum24 Cabs offers comfortable and timely taxi services from Pune to the famous Ajanta and Ellora caves."
    },
    {
      "WhyChooseheading": "Experienced Drivers with Route Expertise",
      "WhyChoosedescription": "Our skilled drivers know the best routes to ensure a smooth and safe journey to Ajanta and Ellora."
    },
    {
      "WhyChooseheading": "Clean and Air-Conditioned Vehicles",
      "WhyChoosedescription": "Travel in sanitized, well-maintained cabs that keep you comfortable throughout your trip."
    },
    {
      "WhyChooseheading": "Flexible Booking Options for One-Way and Round Trips",
      "WhyChoosedescription": "Choose packages that fit your sightseeing schedule and travel preferences."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
      "WhyChoosedescription": "Enjoy upfront fares inclusive of fuel, tolls, and driver allowances."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Hassle-Free Booking",
      "WhyChoosedescription": "Our dedicated team is available anytime to assist with bookings and travel queries."
    },
    {
      "WhyChooseheading": "Ideal for Tourist Groups and Family Outings",
      "WhyChoosedescription": "Perfect for exploring the historic caves with friends and family in comfort."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options to Suit Your Group Size",
      "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, or tempo travellers based on your needs."
    }
  ]





















    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs provide cab services from Pune to Ajanta Ellora?',
        answer: 'Yes, Platinum24 Cabs offers comfortable and reliable cab services from Pune to the Ajanta and Ellora caves for sightseeing and travel.',
    },
    {
        question: 'How can I book a Pune to Ajanta Ellora cab with Platinum24 Cabs?',
        answer: 'You can easily book your Pune to Ajanta Ellora cab through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of vehicles are available for Pune to Ajanta Ellora trips?',
        answer: 'We offer a range of vehicles including sedans, SUVs, and tempo travellers suitable for individual travelers and groups.',
    },
    {
        question: 'Are the drivers experienced for long-distance travel to Ajanta Ellora?',
        answer: 'Yes, our drivers are professional, experienced, and familiar with the route from Pune to Ajanta and Ellora caves.',
    },
    {
        question: 'Can I book a round trip cab for Pune to Ajanta Ellora?',
        answer: 'Absolutely! We provide round-trip cab services with flexible scheduling to fit your sightseeing plans.',
    },
    {
        question: 'What is included in the fare for Pune to Ajanta Ellora cab services?',
        answer: 'The fare includes vehicle charges, driver allowance, fuel, tolls, and taxes. Additional charges may apply for extra stops or waiting time.',
    },
    {
        question: 'Can I customize pickup and drop-off locations for Pune to Ajanta Ellora rides?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points along the Pune to Ajanta Ellora route.',
    },
    {
        question: 'Are safety and hygiene protocols followed during the trip?',
        answer: 'All vehicles are regularly sanitized, and our drivers adhere to strict safety measures for your protection.',
    },
    {
        question: 'Is it possible to hire a cab for multiple days for sightseeing around Ajanta Ellora?',
        answer: 'Yes, we offer hourly and multi-day rental packages tailored to your sightseeing itinerary.',
    },
    {
        question: 'Does Platinum24 Cabs provide corporate travel services for Pune to Ajanta Ellora?',
        answer: 'Yes, we offer customized corporate travel solutions including priority support and flexible billing.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Rohit Patil',
        feedback: 'The cab service from Pune to Ajanta Ellora was excellent. The driver was punctual and the vehicle was very comfortable.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Kavita Deshmukh',
        feedback: 'A wonderful experience traveling to Ajanta and Ellora caves with Platinum24 Cabs. Highly recommended!',
        rating: 5,
    },
];






























































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];







const ajantaElloraTaxiSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Trusted Pune to Ajanta Ellora Taxi Service offering cab rentals, private taxis, and affordable packages for Ajanta Ellora tours with professional drivers.",
  "areaServed": {
    "@type": "Place",
    "name": "Pune"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Pune to Ajanta Ellora Taxi Packages",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "One Way Cab Pune to Ajanta Ellora"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Round Trip Taxi Pune to Ajanta Ellora"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Pilgrimage Taxi Service Pune to Ajanta Ellora"
        }
      }
    ]
  },
  "serviceType": [
    "Pune to Ajanta Ellora Taxi",
    "Ajanta Ellora Cab from Pune",
    "Pune Ajanta Ellora Taxi Booking",
    "Taxi Service Pune to Ajanta Ellora",
    "Ajanta Ellora Cab Rental Pune",
    "Pune to Ajanta Ellora Taxi Fare",
    "Ajanta Ellora Private Taxi Pune",
    "Ajanta Ellora Cab Packages Pune",
    "Pune to Ajanta Ellora One Way Cab",
    "Taxi Charges Pune to Ajanta Ellora",
    "Pune to Ajanta Ellora Taxi Hire",
    "Ajanta Ellora Pilgrimage Taxi Pune",
    "Pune Ajanta Ellora Outstation Taxi",
    "Ajanta Ellora Taxi with Driver Pune",
    "Taxi Service Pune to Ajanta Ellora"
  ],
  "telephone": "+91-XXXXXXXXXX"
};







    return (
        <div>

<Helmet>
  <title>Pune to Ajanta Ellora Taxi Service | Ajanta Ellora Cab Booking Pune</title>
  <meta
    name="description"
    content="Trusted Pune to Ajanta Ellora Taxi Service offering cab rentals, private taxis, and affordable packages for Ajanta Ellora tours with professional drivers."
  />
  <meta
    name="keywords"
    content="Pune to Ajanta Ellora Taxi, Ajanta Ellora Cab from Pune, Pune Ajanta Ellora Taxi Booking, Taxi Service Pune to Ajanta Ellora, Ajanta Ellora Cab Rental Pune, Pune to Ajanta Ellora Taxi Fare, Ajanta Ellora Private Taxi Pune, Ajanta Ellora Cab Packages Pune, Pune to Ajanta Ellora One Way Cab, Taxi Charges Pune to Ajanta Ellora, Pune to Ajanta Ellora Taxi Hire, Ajanta Ellora Pilgrimage Taxi Pune, Pune Ajanta Ellora Outstation Taxi, Ajanta Ellora Taxi with Driver Pune, Taxi Service Pune to Ajanta Ellora"
  />
  <script type="application/ld+json">
    {JSON.stringify(ajantaElloraTaxiSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/70.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoalibaugelloracabs;